





import { Component, Vue } from 'vue-property-decorator';
import * as utils from '@/utils';
import * as utils_tracker from '@/utils_tracker';
import { Click, clickType } from '@/Click'
import { TokenUser } from '@/TokenUser'


@Component({
  name: 'Goto',
  components: {}
})
// e.g. https://livetoken.co/goto/moment/123456?type=0&value=18
export default class Goto extends Vue {
  // prop reactive member variables publically available to the html template

  // public reactive member variables available to the html template

  public get loading(): boolean { return this.$store.state.loading }
  public get isAuthenticated(): boolean { return this.$store.getters.isAuthenticated }
  public get user(): TokenUser { return this.$store.getters.userObject }

  // public functions available to the html template

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    utils_tracker.page(this.$options.name)

    // get code from URL
    const linkType: string = this.$route.params.linkType
    const payload: string = this.$route.params.payload

    // get type from URL
    const rawType = this.$route.query.type
    const type: clickType = rawType !== null && rawType !== undefined ? Number(this.$route.query.type) : null
    const value: number = this.$route.query.value !== null && this.$route.query.value !== undefined ? Number(this.$route.query.value) : null
    const flowty: number = this.$route.query.flowty !== null && this.$route.query.flowty !== undefined ? Number(this.$route.query.flowty) : null

    // TODO: add TS affiliate links
    let externalURL: string
    if (linkType === 'moment') {
      if (flowty) {
        // if (type === clickType.GoneDeal) externalURL = `https://www.flowty.io/collection/0x0b2a3299cc857e29/TopShot/activity/storefront` // commented out because of 404
        // else externalURL = `https://flowty.io/asset/0x0b2a3299cc857e29/TopShot/NFT/${payload}?listingResourceID=${flowty}`
        externalURL = `https://www.flowty.io/asset/0x0b2a3299cc857e29/TopShot/NFT/${payload}?listingResourceID=${flowty}`
      } else {
        externalURL = `https://nbatopshot.com/moment/${payload}`
      }
    }
    if (linkType === 'p2p') externalURL = `https://nbatopshot.com/listings/p2p/${payload.replace('_', '+')}`
    if (linkType === 'superdraft') {
      // default
      externalURL = 'https://superdraft.io/register?utm_source=affiliate&utm_campaign=Live-Token&cid=Live-Token'

      if (payload === 'signupMoreInfo') externalURL = 'https://play.superdraft.io/summer-madness-live-token/'
      if (payload === 'register') externalURL = 'https://superdraft.io/register?utm_source=affiliate&utm_campaign=Live-Token&cid=Live-Token'
      if (payload === 'register2') externalURL = 'https://superdraft.io/register?utm_source=affiliate&utm_campaign=Live-Token&cid=Live-Token'
      if (payload === 'day2') externalURL = 'https://superdraft.io/draft?contestId=522550&utm_source=affiliate&utm_campaign=Live-Token&cid=Live-Token'
      if (payload === 'day3') externalURL = 'https://superdraft.io/draft?contestId=522982&utm_source=affiliate&utm_campaign=Live-Token&cid=Live-Token'
      if (payload === 'day4') externalURL = 'https://superdraft.io/draft?contestId=523845&utm_source=affiliate&utm_campaign=Live-Token&cid=Live-Token'
      // if (payload === 'register') externalURL = 'https://app.adjust.com/qz8cwcb?redirect_macos=https://superdraft.io/register?utm_source=affiliate?utm_campaign=Live-Token?cid=Live-Token&redirect_windows=https://superdraft.io/register?utm_source=affiliate?utm_campaign=Live-Token?cid=Live-Token'

      if (payload === 'teamLander') externalURL = 'https://play.superdraft.io/team-LiveToken/?utm_source=affiliate&utm_campaign=Live-Token&cid=Live-Token'
      if (payload === 'teamDay1P') externalURL = 'https://superdraft.io/draft?contestId=538500&utm_source=affiliate&utm_campaign=Live-Token&cid=Live-Token'
      if (payload === 'teamDay1F') externalURL = 'https://superdraft.io/draft?contestId=538514&utm_source=affiliate&utm_campaign=Live-Token&cid=Live-Token'

    }



    // console.log(externalURL)

    // go to externalURL
    if (externalURL) {
      window.location.href = externalURL;
    } else {
      try { await this.$router.push({ name: 'home' }) } catch (Error) { }
    }

    // Feb 22, 2024 -- record the click in the DB
    const clicker: string = this.user && this.user._temp && this.user._temp.account ? this.user._temp.account.flowAddress : null
    async function recordClick(click: Click) {
      try {
        const url: string = utils.getURLprefix() + "/api/utils/click";
        await utils.makePostCall(url, { click });
      } catch (error) {
        console.error('recordClick', error)
      }
    }

    if (externalURL && type !== null) {
      if (type === clickType.Deal || type === clickType.GoneDeal) {
        const momentID: number = Number(payload)
        const click: Click = new Click(null, type, clicker, momentID, value, !!flowty)
        await recordClick(click)
      }

      if (type === clickType.Listing) {
        const momentID: number = Number(payload)
        const click: Click = new Click(null, type, clicker, momentID, value, !!flowty) 
        await recordClick(click)
      }

      if (type === clickType.Offer) {
        const momentID: number = Number(payload)
        const click: Click = new Click(null, type, clicker, null, value, !!flowty) 
        await recordClick(click)
      }

      if (type === clickType.Alert) {
        const momentID: number = Number(payload)
        const click: Click = new Click(null, type, clicker, momentID, value, !!flowty) 
        await recordClick(click)
      }
    }

  }

}

